export default {
  driver_performance_events_title: "Rendimiento del Conductor - Eventos",
  driver_performance_events_event: "Evento",
  driver_performance_events_date: "Fecha",
  driver_performance_events_driver: "Conductor",
  driver_performance_events_asset: "Activo",
  driver_performance_events_refCase: "Ref Caso",
  driver_performance_events_actions: "Acciones",
  driver_performance_events_status: "Estado",
  driver_performance_events_tag: "Etiqueta",
  driver_performance_events_custom: "Personalizado",
  driver_performance_events_today: "Hoy",
  driver_performance_events_yesterday: "Ayer",
  driver_performance_events_week: "Esta Semana",
  driver_performance_events_lastWeek: "La Semana Pasada",
  driver_performance_events_thisMonth: "Este Mes",
  driver_performance_events_lastMonth: "El Mes Pasado",
  driver_performance_events_quarter: "Este Trimestre",
  driver_performance_events_lastQuarter: "El Trimestre Pasado",
  driver_performance_tagId: "ID de Etiqueta",
  driver_performance_tagName: "Nombre de Etiqueta",
  driver_performance_searchInput: "Buscar por Evento, Conductor y Activo",
  driver_performance_noMoreItems: "No hay más elementos",
  driver_performance_coachnow: "Entrenar Ahora",
  driver_performance_createincident: "Crear Incidente",
  driver_performance_falsepositive: "Falso Positivo",
  driver_performance_highlightcoaching: "Cola para Entrenamiento",
  driver_performance_verified: "Verificado",
  driver_performance_noissue: "Sin Problema",
  driver_performance_disputed: "Disputado",
  driver_performance_noDriver: "Sin Conductor",
  driver_performance_assignDriver: "Asignar Conductor",
  
  driver_performance_events_last7days: "Últimos 7 días",
  driver_performance_events_last15days: "Últimos 15 días",
  driver_performance_events_last30Days: "Últimos 30 días",

  driver_performance_events_sendToCoaching: "Enviar a Entrenamiento",
  driver_performance_events_coach_now: "Entrenar Ahora",
  driver_performance_events_assignDriver: "Asignar Conductor",
  driver_performance_events_setStatus: "Establecer Estado",
  driver_performance_noDriversSelected: "No hay conductores seleccionados para el entrenamiento",

  driver_performance_bulkoptions: "Opciones Masivas",
  driver_performance_bulkoptions_sendToCoaching: "Enviar a Entrenamiento",
  driver_performance_bulkoptions_setStatus: "Establecer Estado",
  driver_performance_bulkoptions_selected_limit: "Usted no puede seleccionar más de 100 eventos para opciones masivas.",

  driver_performance_events_withoutDriver: "No se puede enviar a entrenamiento: Algunos eventos no tienen un conductor asignado. Por favor asigne conductores primero.",
  driver_performance_noValidEvents: "No hay eventos válidos para enviar a entrenamiento",
  driver_performance_driversWithoutEvents: "Algunos conductores no tienen eventos asignados",

  driver_performance_events_withCase: "No se puede enviar a entrenamiento: {count} evento(s) ya tienen un caso asignado. Por favor, deseleccione los eventos con casos existentes.",
  driver_performance_drivers_petition_coach_now: "El proceso para el entrenamiento masivo que genera casos automáticamente ha comenzado con éxito.",
  driver_performance_events_not_active_in_asset_profile: "Los siguientes eventos de riesgo no están activos: {events}.",
  driver_performance_events_warning: "Advertencia",
};
